import StringUtils from "@utils/string.utils.ts";
import { isDefined } from "@utils/var.check.ts";

export const getSearchPageByBrowsePageRouteName = (browsePageRouteName: string) => {
  // uses current route (i.e. which browse page) to decide which search page to navigate to.
  // opposite of getBrowsePageBySearchPageRouteName.
  switch (browsePageRouteName) {
    case "FindCommunityGallery":
      return "CommunityGallerySearch";
    case "FindMoeLibrary":
    case "MoeLibraryContentMap":
    case "MoeLibraryModuleBrowse":
      return "MoeLibrarySearch";
    case "FindResource":
      return "ResourceSearch";
    default:
      return "ResourceSearch";
  }
};

export const formattedViewCount = (viewCount: number) => {
  if (isDefined(viewCount)) {
    viewCount = StringUtils.formatNumberWithAbbreviation(viewCount);
  }
  return viewCount;
};
